import React from 'react';

import { Link } from '@/components/common';
import Breadcrumb from '@/components/display/headers/breadcrumb';

const ContactUsPageLayout = (): JSX.Element => {
    return (
        <main className="border-b xl:border-none w-full">
            <div className="p-12 border-b">
                <Breadcrumb
                    items={[
                        {
                            title: 'Contact Us',
                            link: '/contact-us',
                        },
                    ]}
                />
                <div className="">
                    <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">Contact Us</h1>
                </div>
            </div>
            <div className="p-12">
                <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-10">
                    <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3 p-10 border border-[#b4b4b4]/[0.35]">
                        <h2 className="self-stretch flex-grow-0 flex-shrink-0 text-[28px] text-left text-[#110b29]">
                            News
                        </h2>
                        <p className="self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                            <p className="pb-4 self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                Have a hot tip or news to share? Email us at{' '}
                                <Link href="mailto:news@blockworks.co" className="text-brand hover:text-dark">
                                    news@blockworks.co
                                </Link>
                                .
                            </p>

                            <p className="pb-4 self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                Want to let the industry know about a new hire? Email us at{' '}
                                <Link href="mailto:news@blockworks.co" className="text-brand hover:text-dark">
                                    news@blockworks.co
                                </Link>{' '}
                                and put “HIRING UPDATE” in the subject line.
                            </p>

                            <p className="self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                To share a press release with us, paste the release into the body of the email so we can
                                read it quickly and easily. Please do not send attachments.
                            </p>
                        </p>
                    </div>
                    <div className="flex flex-col lg:flex-row justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-10">
                        <div className="w-full flex flex-col justify-start items-start flex-grow relative gap-3 p-10 border border-[#b4b4b4]/[0.35]">
                            <h3 className="self-stretch flex-grow-0 flex-shrink-0 text-[28px] text-left text-[#110b29]">
                                Sales &amp; Advertising
                            </h3>
                            <p className="self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                For information on advertising with Blockworks, contact us through our{' '}
                                <Link href="/advertise" className="text-brand hover:text-dark">
                                    advertising page
                                </Link>
                                .
                            </p>
                        </div>
                        <div className="w-full flex flex-col justify-start items-start flex-grow relative gap-3 p-10 border border-[#b4b4b4]/[0.35]">
                            <h3 className="self-stretch flex-grow-0 flex-shrink-0 text-[28px] text-left text-[#110b29]">
                                Events &amp; Roundtables
                            </h3>
                            <p className="self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                Email our events and roundtables team at{' '}
                                <Link href="mailto:events@blockworks.co" className="text-brand hover:text-dark">
                                    events@blockworks.co
                                </Link>{' '}
                                or inquire about sponsorship opportunities here.{' '}
                            </p>
                        </div>
                        <div className="w-full flex flex-col justify-start items-start flex-grow relative gap-3 p-10 border border-[#b4b4b4]/[0.35]">
                            <h3 className="self-stretch flex-grow-0 flex-shrink-0 text-[28px] text-left text-[#110b29]">
                                Hiring &amp; Careers
                            </h3>
                            <p className="self-stretch flex-grow-0 flex-shrink-0 text-lg text-left text-[#110b29]">
                                Check out the careers page to view our open positions or email us at{' '}
                                <Link href="mailto:careers@blockworks.co" className="text-brand hover:text-dark">
                                    careers@blockworks.co
                                </Link>
                                .
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ContactUsPageLayout;
